// import React from "react";
// import { NavLink } from "react-router-dom";
// import { Nav } from "react-bootstrap";
// import {
//   FaTachometerAlt,
//   FaUsers,
//   FaFileInvoiceDollar,
//   FaCog,
//   FaUserPlus,
//   FaChartBar,
//   FaDumbbell,
// } from "react-icons/fa";
// // import "./Sidebar.css";

// const Sidebar = () => {
//   const menuItems = [
//     { path: "/dashboard", icon: <FaTachometerAlt />, label: "Dashboard" },
//     { path: "/members", icon: <FaUsers />, label: "Members" },
//     {
//       path: "/membership/plans",
//       icon: <FaDumbbell />,
//       label: "Membership Plans",
//     },
//     {
//       path: "/payments",
//       icon: <FaFileInvoiceDollar />,
//       label: "Pending Payments",
//     },
//     {
//       path: "/members/expiry/report",
//       icon: <FaUserPlus />,
//       label: "Expiry Report",
//     },
//     { path: "/members/report", icon: <FaChartBar />, label: "Reports" },

//     {
//       path: "/settings/subscription-types",
//       icon: <FaCog />,
//       label: "Settings",
//     },
//     { path: "/register", icon: <FaUserPlus />, label: "User Create" },
//   ];

//   return (
//     <div className="sidebar">
//       <div className="sidebar-header">
//         <h5 className="text-center mb-0">Menu</h5>
//       </div>

//       <Nav className="flex-column">
//         {menuItems.map((item) => (
//           <NavLink
//             key={item.path}
//             to={item.path}
//             className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
//           >
//             <span className="nav-icon">{item.icon}</span>
//             <span className="nav-label">{item.label}</span>
//           </NavLink>
//         ))}
//       </Nav>

//       <div className="sidebar-footer">
//         <small className="text-muted">Version 1.0.0</small>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "react-bootstrap";
import {
  FaTachometerAlt,
  FaUsers,
  FaFileInvoiceDollar,
  FaCog,
  FaUserPlus,
  FaChartBar,
  FaDumbbell,
} from "react-icons/fa";

const Sidebar = () => {
  const menuItems = [
    {
      path: "/dashboard",
      icon: <FaTachometerAlt />,
      label: "Dashboard",
      exact: true,
    },
    { path: "/members", icon: <FaUsers />, label: "Members", exact: true },
    {
      path: "/membership/plans",
      icon: <FaDumbbell />,
      label: "Membership Plans",
    },
    {
      path: "/payments",
      icon: <FaFileInvoiceDollar />,
      label: "Pending Payments",
    },
    {
      path: "/members/expiry/report",
      icon: <FaUserPlus />,
      label: "Expiry Report",
    },
    { path: "/members/report", icon: <FaChartBar />, label: "Reports" },
    {
      path: "/settings/subscription-types",
      icon: <FaCog />,
      label: "Settings",
    },
    {
      path: "/register",
      icon: <FaUserPlus />,
      label: "User Create",
      exact: true,
    },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h5 className="text-center mb-0">Menu</h5>
      </div>

      <Nav className="flex-column">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.exact}
            className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </NavLink>
        ))}
      </Nav>

      <div className="sidebar-footer">
        <small className="text-muted">Version 1.0.0</small>
      </div>
    </div>
  );
};

export default Sidebar;
